import WordPress from './filters/_wordpress.js';
import Swiftype from './filters/_swiftype.js';

const instances = [];

const factory = function( selector = '.filters', opts = {} ) {
	return Array.from( document.querySelectorAll( selector ) ).map( node => {
		let FilterType = node.dataset.type.toLowerCase() === 'wordpress' ? WordPress : Swiftype;

		const instance = new FilterType( node, opts );

		instances.push( instance );

		return instance;
	} );
}

factory.instances = instances;

factory();

export default factory;
